import React from "react";
import { AppContext } from "./AppContext"
const Header = ({ isMobile }) => {

    return (
        isMobile ? <AppContext.Consumer>
            {value => {
                return (
                    <div className="header">
                        <img width={250} src="/images/fitpass_with_yono.png" />
                        {/* <div onClick={!value.showVideo && value.setShowVideo} className="f12 c1" style={{ textDecoration: "underline" }}>What is Fitpass</div> */}
                    </div>
                )
            }}
        </AppContext.Consumer>
            : <div className="header">
                <img height="30px" src="/images/fitpass_logo_ic.svg" />
                <img height="30px" src="/images/sbi_yono_logo.svg" />
            </div>
    )
}

export default Header;